export default {
  home: {
    hero: {
      badge: 'Centro de recursos de compras 2026',
      title: 'Tu recurso completo de Basetao Spreadsheet',
      subtitle:
        'Encuentra hojas de cálculo de Basetao útiles, enlaces de productos, guías de vendedores, consejos de QC y ayuda de envío — todo organizado en un solo lugar.',
      trust: 'Recurso informativo independiente para compradores de Basetao.',
      categoryLabel: 'Explorar por categoría',
      categoryPlaceholder: 'Elige una categoría…',
    },
    categories: {
      title: 'Comprar por categoría',
      subtitle: 'Ve directamente a los productos que quieres en el sitio principal.',
    },
    intro: {
      eyebrow: 'Qué es',
      title: '¿Qué es una hoja de cálculo de Basetao?',
      p1: 'Una hoja de cálculo de Basetao es un documento organizado que te ayuda a seguir cada producto, vendedor, precio y detalle de QC mientras compras a través del agente Basetao.',
      p2: 'Mantiene tus enlaces, tallas, colores y el progreso del envío en un solo lugar, para que nunca pierdas el hilo de un pedido ni gastes de más por accidente.',
    },
    features: {
      title: 'Todo lo que necesitas para comprar de forma más inteligente',
      subtitle: 'De los enlaces de productos a la entrega final, mantente organizado en cada paso.',
      items: [
        {
          title: 'Categorías seleccionadas',
          desc: 'Explora 14 categorías de productos y ve directo a lo que quieres.',
        },
        {
          title: 'Guías de vendedores',
          desc: 'Entiende cómo comparar tiendas y elegir vendedores de confianza.',
        },
        {
          title: 'Consejos de QC',
          desc: 'Conoce qué revisar antes de que tus artículos salgan del almacén.',
        },
        {
          title: 'Ayuda de envío',
          desc: 'Familiarízate con los métodos de envío y los conceptos básicos de costos.',
        },
      ],
    },
    articleTeaser: {
      eyebrow: 'Guía destacada',
      title: 'La guía completa de Basetao Spreadsheet',
      desc: 'Aprende a crear y usar una hoja de cálculo de Basetao para organizar enlaces de productos, vendedores, fotos de QC y detalles de envío.',
      readMore: 'Leer la guía completa',
    },
    faq: {
      title: 'Preguntas frecuentes',
      items: [
        {
          q: '¿Qué es Basetao Spreadsheet?',
          a: 'Es un recurso informativo que organiza enlaces de productos, categorías y guías de compra para ayudar a los compradores de Basetao a encontrar más rápido lo que necesitan.',
        },
        {
          q: '¿Venden productos directamente?',
          a: 'No. Enlazamos al sitio principal donde puedes explorar y comprar los productos.',
        },
        {
          q: '¿Es este el sitio web oficial de Basetao?',
          a: 'No. Este es un recurso informativo independiente y no es el sitio web oficial de Basetao, salvo que se indique explícitamente.',
        },
        {
          q: '¿Cómo uso el menú desplegable de categorías?',
          a: 'Abre el menú, elige una categoría y serás llevado a la página correspondiente en el sitio principal.',
        },
      ],
    },
    finalCta: {
      title: '¿Listo para explorar los recursos de Basetao Spreadsheet?',
      subtitle: 'Explora las categorías de abajo o visita el sitio principal para empezar a comprar.',
    },
  },
};